// export const ApiUrl = `${
//   window.location.hostname === "localhost"
//     ? "http://localhost:8000"
//     : "https://admin.fprz.ru"
// }`;

// export const API_MEDIA = "http://localhost:80/";

export const ApiUrl = `${
  window.location.hostname === "localhost"
    ? "http://localhost:8000"
    : "https://test.fprz.ru"
}`;

export const ApiUrlStatic = `${
  window.location.hostname === "localhost"
    ? "http://localhost:3000"
    : "https://test.fprz.ru"
}`;

export const API_MEDIA = `${
  window.location.hostname === "localhost"
    ? "http://localhost:8000/api"
    : "https://test.fprz.ru"
}`;

export const ADMIN = `${
  window.location.hostname === "localhost"
    ? "http://localhost:8000/api/admin/"
    : "https://test.fprz.ru/api/admin/"
}`;
// export const API_MEDIA = "https://test.fprz.ru";

//6LcdukgtAAAAAKjrvId1k68QXv7qadjAGlLjj6QD   это ключ сайта рекапчи fprz.ru
//6LcdukgtAAAAANjSipCG61LwMJKnqsxKXcEKhagx это секретный ключ капчи fprz.ru

//6LcQwUgtAAAAALuvnJnjN4S9Dqy7G3FWzS54LznZ  это ключ сайта рекапчи localhost
//6LcQwUgtAAAAADWFbKLso0BxmE7dmAXMsiWg1Xwi это секретный ключ капчи fprz.ru
export const SITE_KEY_CAPTCHA = "6LcQwUgtAAAAALuvnJnjN4S9Dqy7G3FWzS54LznZ";
